<div class="details-wrapper">
    <ng-content select="[details-wrapper-body]"></ng-content>
</div>
